import { render } from "./FixPriceComponent.vue?vue&type=template&id=5d2c1afa"
import script from "./FixPriceComponent.vue?vue&type=script&lang=js"
export * from "./FixPriceComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/lots/FixPriceComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d2c1afa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d2c1afa', __exports__)) {
    console.log('reload')
    api.reload('5d2c1afa', __exports__)
  }
  
  module.hot.accept("./FixPriceComponent.vue?vue&type=template&id=5d2c1afa", () => {
    console.log('re-render')
    api.rerender('5d2c1afa', render)
  })

}


export default __exports__